//@ts-ignore
const mSpine = spine;
export default mSpine;
